// Conversion values represent estimated lifetime value of each shipper type
// These values help Google Ads optimize toward high-value customers
export function calculateConversionValueFromShipmentFrequency(
  shipmentFrequency: string | undefined,
): number {
  switch (shipmentFrequency) {
    case "Daily":
      return 1500.0;
    case "Weekly":
      return 1000.0;
    case "Occasional":
      return 100.0;
    case undefined:
      return 0.0;
    default:
      return 0.0;
  }
}
